import { Badge } from "reactstrap";

const SpecialIcon = () => {
  return (
    <Badge className="badge-dim" color="primary">
      ویژه
    </Badge>
  );
};

export default SpecialIcon;
